export const BUTTONS_TYPE = [
    'accessibility',
    'displayOverlay',
    'explosion',
    'tutorial',
];
export const BUTTON_VISIBILITY_VALUES = [
    'hidden',
    'visible',
    'overlay',
    'embedded',
];
